import moment from "moment";
import http from "./interceptor";

const request = ({
  url = "",
  method = "GET",
  headers = {},
  params = {},
  data = {},
}) => {
  const comHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Date": moment().toISOString(),
    ...headers,
  };
  switch (method) {
    case "GET":
      return http.get(url, { headers: comHeaders, params, data });
    case "POST":
      return http.post(url, data, { headers: comHeaders });
    case "PUT":
      return http.put(url, data, { headers: comHeaders });
    case "DELETE":
      return http.delete(url, { headers: comHeaders, params, data });
    default:
      break;
  }
};

export default request;
